import * as React from 'react';
import * as autoBind from 'react-autobind';
import {BasicModal, AlertModal, TscButtonType} from '@techsmith/tsc-cloud-style-guide';
import ReviewerGroupModel from '../../types/ReviewerGroupModel';
import ReviewerGroupsList from '../ReviewerGroupsList/ReviewerGroupsList';
import AddReviewerGroupContainer from '../AddReviewerGroup/AddReviewerGroupContainer';
import Strings from '../../globals/Strings';
import Themeable from '../../types/Themeable';

export default class ReviewerGroupsModal extends React.Component<ReviewGroupsModalProps, ReviewGroupsModalState> {
   readonly state: ReviewGroupsModalState = {
      bannerText: Strings.labels.manageGroups,
      isEditing: false,
      selectedGroup: null,
      hasPendingChanges: false,
      showAlert: false
   };

   private onAlertAcceptCallback: () => void;

   constructor(props: ReviewGroupsModalProps) {
      super(props);
      autoBind(this);

      this.onAlertAcceptCallback = () => null;
   }

   setHasPendingChanges(hasPendingChanges: boolean): void {
      this.setState({hasPendingChanges});
   }

   onClose(): void {
      this.onAlertAcceptCallback = this.props.onClose;

      if (this.state.hasPendingChanges) {
         this.setState({showAlert: true});
      } else {
         this.onAlertAcceptCallback();
      }
   }

   onCancel(): void {
      this.onAlertAcceptCallback = () => {
         this.setState({isEditing: false, selectedGroup: null, bannerText: Strings.labels.manageGroups, showAlert: false});
      };

      if (this.state.hasPendingChanges) {
         this.setState({showAlert: true});
      } else {
         this.onAlertAcceptCallback();
      }
   }

   onEdit(reviewerGroup: ReviewerGroupModel): void {
      this.setState({selectedGroup: reviewerGroup, isEditing: true, bannerText: Strings.labels.editGroup});
   }

   onNewGroup(): void {
      this.setState({selectedGroup: null, isEditing: true, bannerText: Strings.labels.createGroup});
   }

   onCancelWarn(): void {
      this.setState({showAlert: false});
   }

   onConfirmWarn(): void {
      this.setState({hasPendingChanges: false, showAlert: false, isEditing: false});
      this.onAlertAcceptCallback();
   }

   render(): React.ReactElement<any> {
      const {reviewerGroups, themeName} = this.props;
      const {bannerText, isEditing, selectedGroup, showAlert} = this.state;
      const {unsavedChanges, cancel, discard, alertText} = Strings.labels.reviewerGroupsModal;

      return (
            <BasicModal title={bannerText} onClose={this.onClose} themeName={themeName}>
               <div className="modal-body">
                  {!isEditing && <ReviewerGroupsList themeName={themeName} reviewerGroups={reviewerGroups} onClose={this.onClose} onCreate={this.onNewGroup} onEdit={this.onEdit}/>}
                  {isEditing && <AddReviewerGroupContainer reviewerGroup={selectedGroup} reviewerGroups={reviewerGroups} onCancel={this.onCancel} setHasPendingChanges={this.setHasPendingChanges}/>}
                  {showAlert && <AlertModal title={unsavedChanges}
                     onClose={this.onCancelWarn}
                     closeContent={cancel}
                     onDismiss={this.onCancelWarn}
                     dismissContent={cancel}
                     onConfirm={this.onConfirmWarn}
                     confirmContent={discard}
                     confirmButtonType={TscButtonType.destructive}
                     testId="reviewer-groups-modal-alert">
                     {alertText}
                  </AlertModal>}
               </div>
            </BasicModal>
      );
   }
}

export interface ReviewGroupsModalProps extends Themeable {
   reviewerGroups: ReviewerGroupModel[];
   onClose(): void;
}

export interface ReviewGroupsModalState {
   bannerText: string;
   isEditing: boolean;
   selectedGroup: ReviewerGroupModel;
   hasPendingChanges: boolean;
   showAlert: boolean;
}
